const SVGIconWrapper = (props) => {
    return (
        <span className={`svg-icon-wrap ${props.wrapperClass}`}>
            <svg
                onClick={props.onClick}
                fill={props.fill}
                style={props.style}
                viewBox={props.viewBox}
                className={`icon ${props.iconClass}`}
            >{props.children}</svg>
        </span>
    )
}

export default SVGIconWrapper